// extracted by mini-css-extract-plugin
module.exports = {"safeAppTagContainer":"styles_safeAppTagContainer__NWdpE","safeAppTagLabel":"styles_safeAppTagLabel__HE3W7"};